  
<template>
  <div>
    <b-navbar
      v-bind:class="{ 'bg-perso2 text-blu' : navbarbg, 'bg-perso' : navtoggle, 'nav-azul' : colorHeader }"
      class="navbar w-100"
      toggleable="lg"
      type="dark"
      fixed="top"
    >
      <b-navbar-brand class="brand d-flex align-items-center justify-content-center">
        <router-link to="/">
          <img src="../../../assets/ADG.png" height="38" class="imagen-logo" />
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" v-cloak></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-md-auto">
          <b-nav-item href="#">
            <router-link to="/">Inicio</router-link>
          </b-nav-item>
          <b-nav-item href="#">
            <router-link to="/productos">Productos</router-link>
          </b-nav-item>
          <!-- <b-nav-item href="#">
            <router-link to="/noticias">Blog</router-link>
          </b-nav-item> -->
          <b-nav-item href="#">
            <router-link to="/nosotros">Nosotros</router-link>
          </b-nav-item>
          <b-nav-item href="#">
            <router-link to="/clientes">Clientes</router-link>
          </b-nav-item>
          <b-nav-item href="#">
            <router-link to="/contacto">Contacto</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      navtoggle: false,
      navbarbg: false,
      screeValueActual: 0,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    ...mapState(["colorHeader"])
  },
  methods: {
    //Cambiar el navbar de color
    handleScroll() {
      //Valor del eje Y del scroll
      var scrollPos = window.scrollY;
      if (scrollPos > 0) {
        this.navbarbg = true;
      } else {
        this.navbarbg = false;
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      if (this.window.width > 1000) {
        this.navtoggle = false;
      } else {
        this.navtoggle = true;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style scoped>
.brand {
  height: 100%;
  border-radius: 10px;
}
.brand,
.nav-item a {
  transition: transform 0.2s;
  -o-transition: transform 0.2s;
  -moz-transition: transform 0.2s;
  -webkit-transition: transform 0.2s;
}

.brand:hover,
.nav-item a:hover {
  
  font-weight: bold;
  text-decoration: none;
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
}
.navbar {
  padding: 4px 6%;
  -webkit-transition: background-color 0.3s ease-out;
  -moz-transition: background-color 0.3s ease-out;
  -o-transition: background-color 0.3s ease-out;
  transition: background-color 0.3s ease-out;
}
.nav-azul .nav-item a {
  color: #0da2ff;
}
.nav-item a,
.nav-link .dropdown-toggle span {
  margin: 0 !important;
  font-weight: 500;
  font-size: calc(1em + 0.1vw);
  letter-spacing: 0px;
  color: #fff;
  display: block;
  padding: 0.6rem;
}
.nav-item a:hover {
  color: #009cff;
}
.text-blu .nav-item a {
  color: #565656 !important;
}
.nav-item a.router-link-exact-active {
  font-weight: bold;
  text-decoration: underline;
  color: #009cff !important;
}
.text-blu .nav-item a:hover {
  color: #009cff;
}
.bg-perso .show {
  -webkit-transition: background-color 0.3s ease-out;
  -moz-transition: background-color 0.3s ease-out;
  -o-transition: background-color 0.3s ease-out;
  transition: background-color 0.3s ease-out;
  margin-top: 10px;
     -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  background: #009cff;
  padding: 0 !important;
}
.bg-perso .show .nav-item a.router-link-exact-active {
  background: rgba(255, 255, 255, 0.9) !important;
  text-decoration: none;
  margin-left: 0 !important;
}
.bg-perso .show a a:hover {
  background: rgba(255, 255, 255, 0.9) !important;
}

.nav-azul .show a {
  color: white;
}
.nav-azul .show a:hover {
  color: #009cff;
}
.bg-perso2 .show {
  margin-top: 0px;
  box-shadow: none;
  padding: 0 !important;
  background: white !important;
}
.bg-perso2 {
    -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  background: rgba(255, 255, 255, 1);
}
.bg-perso2 .nav-item a.router-link-exact-active {
  color: #009cff !important;
}
@media screen and (max-width: 480px) {
  .navbar {
    padding: 10px 6%;
  }
}
</style>